import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import Wordmark from './Wordmark';
import './Navbar.scss';

export default function Navbar() {
  const { t } = useLocale();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container-x navbar__inner">
        <Link to="/" className="navbar__brand" aria-label="Outfino for Brands home">
          <Wordmark size={34} />
        </Link>

        <nav className="navbar__links">
          <a href="#what">{t('nav.what')}</a>
          <a href="#why">{t('nav.why')}</a>
          <a href="#dashboard">{t('nav.dashboard')}</a>
        </nav>

        <div className="navbar__actions">
          <Link to="/login" className="btn-o btn-o--brand btn-o--sm">
            {t('nav.login')}
          </Link>
        </div>
      </div>
      </header>
      <div className="navbar-spacer" aria-hidden="true" />
    </>
  );
}
